/**
 * 售后订单
 */

import axios from '@/util/request'

export default {
  getAfterSalesOrderList: (data) => axios({ url: '/api/orders/returns', method: 'POST', data }), // 前台-获取售后单列表
  getAfterSalesOrderDetails: (returnsId, params) => axios({ url: `/api/orders/returns/${returnsId}`, method: 'GET', params }), // 前台-获取售后单详情
  getOrderRefundRecord: (kkOrderId, params) => axios({ url: `/api/orders/refund/${kkOrderId}`, method: 'GET', params }), // 获取订单退款记录
  getRefundOrderInformation: (kkOrderId, params) => axios({ url: `/api/orders/refundForm/${kkOrderId}`, method: 'GET', params }), // 前后台-新建退款单页面查询
  createAfterSalesOrder: (kkOrderId, data) => axios({ url: `/api/orders/returns/${kkOrderId}`, method: 'POST', data }), // 前后台-创建售后单
  getRefundOrderAmount: (kkOrderId, data) => axios({ url: `/api/orders/refund/amount/${kkOrderId}`, method: 'POST', data }) // 前后台-退款提交金额查询
}

